<template>
  <article class="feature-page">
    <div class="max-w-4xl mx-auto px-4 py-10">
      <h2 class="text-2xl lg:text-3xl font-bold text-center mb-4">
        piceditor.io Rotate & Flip Image: Instantly Adjust Photo Orientation
      </h2>
      <p class="text-xl text-center mb-6">
        Correct angles or explore creative flips with ease. Simple, fast, and precise.
      </p>

      <p class="mb-4">
        Whether you need to fix a tilted photo or want to flip images for fun effects, our Rotate & Flip tool makes it
        effortless. Rotate left, right, or 180°, and flip horizontally, vertically, or both — all in real time with
        instant previews.
      </p>

      <h3 class="text-2xl font-bold mt-12 mb-6">Why Use Rotate & Flip?</h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 feature-page__specific">
        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/precision.png" alt="precise adjustment" />
          <strong>Precise Adjustment</strong>
          <p>Align your images perfectly with simple rotation and flipping options, ensuring professional results.</p>
        </div>

        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/creative.png" alt="creative control" />
          <strong>Creative Control</strong>
          <p>
            Flip your photos to create mirror effects, unique perspectives, or fun visual twists with minimal effort.
          </p>
        </div>

        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/speed.png" alt="real-time feedback" />
          <strong>Real-time Feedback</strong>
          <p>
            See every change instantly as you rotate or flip, so you get exactly the result you want with no guesswork.
          </p>
        </div>
      </div>

      <h3 class="text-2xl font-bold mt-12 mb-6">How It Works</h3>
      <ol class="list-decimal pl-5 mb-6">
        <li><strong>Upload Your Image:</strong> Drag and drop or select an image from your device.</li>
        <li><strong>Choose Rotation & Flip:</strong> Select rotation angles and flip options for precise control.</li>
        <li><strong>Preview Instantly:</strong> View the results live and adjust until perfect.</li>
        <li><strong>Download & Share:</strong> Save your edited image, ready for any use.</li>
      </ol>

      <p>
        Rotate & Flip works seamlessly across all devices. No software, no hassle — just quick and effective adjustments
        right in your browser.
      </p>
    </div>
  </article>
</template>
